// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  wasmAssetsPath: '/assets/mono',
  firebaseConfig : {
    apiKey: 'AIzaSyBI6F5Yu5_mYnTbRRSz7lNKg0WQHyIkapw',
    authDomain: 'genweb-2a5f6.firebaseapp.com',
    databaseURL: 'https://genweb-2a5f6.firebaseio.com',
    projectId: 'genweb-2a5f6',
    storageBucket: 'genweb-2a5f6.appspot.com',
    messagingSenderId: '81066728073'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
